/* eslint-disable import/no-default-export */
import { Spinner } from 'app/src/components/Spinner';
import React from 'react';

import Help from './help';

interface HelpState {
  loading: boolean;
}

class HelpContainer extends React.Component<object, HelpState> {
  constructor(props: object) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  stopLoading = () => this.setState({ loading: false });

  render() {
    return (
      <>
        {this.state.loading && <Spinner centered />}
        <Help onIFrameLoaded={this.stopLoading} />
      </>
    );
  }
}

export default HelpContainer;
